import { useSelector } from 'react-redux';

export const useDeductible = () => {
  const { activePaidContracts } = useSelector((state) => state.nomadInsurance.contract);

  const activeContractDeductibleAmount = (activePaidContracts || [])[0]?.deductible;

  const displayDeductibleText = activeContractDeductibleAmount === 250;

  return {
    activeContractDeductibleAmount,
    defaultDeductibleAmount: 0,
    contractTotalPrice: 56.28,
    contractTotalPriceInclUSAddon: 104.44,
    displayDeductibleText
  };
};
